import { render } from "./TeamingTiptapCommitment.vue?vue&type=template&id=37011be4&scoped=true"
import script from "./TeamingTiptapCommitment.vue?vue&type=script&lang=js"
export * from "./TeamingTiptapCommitment.vue?vue&type=script&lang=js"

import "./TeamingTiptapCommitment.vue?vue&type=style&index=0&id=37011be4&lang=scss"
import "./TeamingTiptapCommitment.vue?vue&type=style&index=1&id=37011be4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37011be4"

export default script